import { useQuery, UseQueryResult } from 'react-query';
import { CreditRiskLevel } from '../../../models/RiskProducts';
import { CreditRiskLevelMetric } from '../../../services/dtos/riskProducts/creditRiskLevels.dto';
import { fetchCreditRiskLevel } from '../../../services/riskProducts/riskProducts.service';
import { queryKeys } from '../../queryKeyFactory';

export default (
  watchListId: string,
  metric?: CreditRiskLevelMetric,
  rated = true
): UseQueryResult<CreditRiskLevel[]> => {
  return useQuery(
    queryKeys.fetchRiskProducts.dashboard.creditRiskLevel(watchListId, metric!, rated),
    async () => {
      const result = await fetchCreditRiskLevel(watchListId, metric!, rated);
      return result;
    },
    {
      enabled: !!metric,
    }
  );
};
